import classNames from 'clsx';
import React from 'react';
import type { Settings } from 'react-slick';
import Slider from 'react-slick';

import Slide from '../Slide/Slide';

import carousel from './Carousel.scss';
import theme from './CarouselTheme.scss';

interface Props {
  sliderRef?: React.RefObject<Slider | null>;
  slides: string[];
  settings?: Settings;
  carouselClass?: string;
  onSlideClick?(event: React.MouseEvent<HTMLDivElement, MouseEvent>): void;
}

const Carousel: React.FC<Props> = ({
  sliderRef,
  slides,
  settings,
  carouselClass,
  onSlideClick
}) => (
  <div className={classNames(carousel.crmCarousel, theme.crmCarouselTheme, carouselClass)}>
    <Slider ref={sliderRef} {...settings}>
      {slides.map((slide, key) => (
        <div key={key} onClick={onSlideClick}>
          <Slide content={slide} withOverlay={slides.length > 1} />
        </div>
      ))}
    </Slider>
  </div>
);

export default Carousel;
